const { options } = require('./edit-account-status-form-config.js');

module.exports = () => {
  return {
    advertiser_ids: {
      label: '广告主ID',
      type: 'input',
      props: {
        type: 'textarea',
        rows: 5,
        placeholder: '多个广告主ID请用换行隔开',
      },
      rules: [{ required: true, message: '请输入广告主ID', trigger: 'blur' }],
      value: '',
    },
    status: {
      label: '账号状态',
      type: 'radio-group',
      options,
      formItemTips: {
        content: '设为不活跃/弃用后，该账号将停止定时拉取报表与余额（仅活跃账号参与）',
        props: { style: 'color: #F56C6C;' },
      },
      rules: [{ required: true, message: '请选择账号状态', trigger: 'change' }],
      value: '',
    },
  };
};
